import { CompetitionPrice } from "./competition.types";

export enum UserStatus {
  ACTIVE = "active",
  REGISTERED = "registered",
  INACTIVE = "inactive",
}

export const UserStatusTranslations = {
  [UserStatus.ACTIVE]: "Activo",
  [UserStatus.REGISTERED]: "Registrado",
  [UserStatus.INACTIVE]: "Inactivo",
};

export enum UserRoles {
  SYSTEM_ADMIN = 1,
  CLIENT_ADMIN = 2,
  PRIMARY_USER = 3,
  INVITED_USER = 4,
}

export const UserRolesTranslations = {
  [UserRoles.SYSTEM_ADMIN]: "Super Administrador",
  [UserRoles.CLIENT_ADMIN]: "Administrador",
  [UserRoles.PRIMARY_USER]: "Dueño de equipo",
  [UserRoles.INVITED_USER]: "Miembro de equipo",
};

export interface User {
  id: number;
  role_id: UserRoles;
  username: string;
  password: string;
  status: UserStatus;
  created_at: Date;
  updated_at: Date;
}

export interface UserWithDetails {
  id: number;
  role_id: UserRoles;
  username: string;
  status: UserStatus;
  pi_id: number;
  dni: string;
  first_name: string;
  last_name: string;
  birth_date: Date;
  email: string;
  team_id?: number;
  team_name?: string;
}

export type CreateUserDTO = Pick<User, "username"> & {
  role_id?: UserRoles;
  team_id?: number;
};

export interface UserProgress {
  user_id: number;
  team_number?: number;
  is_activated: boolean;
  has_team: boolean;
  has_boat: boolean;
  members_count: number;
  has_helmsman: boolean;
  is_paid: boolean;
  prices: CompetitionPrice[];
}